export const CONSENT_UPDATE = 'CONSENT_UPDATE';

export const consentUpdate = consent => dispatch => {
  dispatch(({ type: CONSENT_UPDATE, payload: { data: consent } }));
};



// WEBPACK FOOTER //
// ./src/reducers/consent/actions.js